import { Request } from 'lib/generated/graphql';
import Link from 'next/link';
import React from 'react';
import ReactMarkdown from 'react-markdown';
import { EditButton } from 'src/shared-components';

const markdownComponents = {
  h1: ({ children }) => <h1 className="text-2xl font-bold">{children}</h1>,
  h3: ({ children }) => <h3 className="text-xl font-bold">{children}</h3>,
  p: ({ children }) => <p className="text-base">{children}</p>,
  ul: ({ children }) => <ul className="list-disc list-inside">{children}</ul>,
  ol: ({ children }) => <ol className="list-decimal list-inside">{children}</ol>,
  li: ({ children }) => <li className="text-base pl-4">{children}</li>,
};

const Brief = ({
  request,
  openModal,
  fullProjectView = false,
  isCurrentUserAllowedToEdit = false,
  showEditButton = false,
}: {
  request: Request;
  fullProjectView?: boolean;
  isCurrentUserAllowedToEdit?: boolean;
  showEditButton?: boolean;
  openModal?: (modal: string) => void;
}) => {
  return (
    <div className="mb-4 text-[#595959] text-[14px] font-medium flex max-w-fit">
      {!fullProjectView ? (
        <span className="truncate">{request?.brief}</span>
      ) : (
        <div>
          {request?.brief.split('  ').map((line: string, index: number) => (
            <div key={index}>
              <ReactMarkdown components={markdownComponents}>
                {line}
              </ReactMarkdown>
              <br />
            </div>
          ))}
        </div>
      )}

      {!fullProjectView && (
        <span className="shrink-0 mr-3">
          <Link href={`/huddles/${request?.slug}`} passHref>
            <a className="cursor-pointer text-gray-900 hover:font-bold">&nbsp;Read More</a>
          </Link>
        </span>
      )}
      {isCurrentUserAllowedToEdit && showEditButton && <EditButton onClick={() => openModal('request')} />}
    </div>
  );
};

export default Brief;
